import {
  httpGetJobs,
  type JobsHttpGetJobsQuery,
} from '@iconik-io/iconik-api/src/services/jobs';

/**
 * The list-valued filters are generated as single strings, but the client
 * serializes arrays with `arrayFormat: 'repeat'` and the endpoint filters on
 * every value given. The index signature carries the filter and facet values
 * the jobs panel sends by name, which no generated type can know.
 */
export type JobsHttpGetJobsQueryPatched = Omit<
  JobsHttpGetJobsQuery,
  'status' | 'type' | 'object_type' | 'created_by'
> & {
  status?: string | string[];
  type?: string | string[];
  object_type?: string | string[];
  created_by?: string | string[];
  [filterName: string]: unknown;
};

export const getJobsRequest = (query: JobsHttpGetJobsQueryPatched) =>
  // biome-ignore lint/plugin: the generated endpoint still declares the single-string filters, see the type above.
  httpGetJobs(query as JobsHttpGetJobsQuery);
